module.exports = __webpack_public_path__ + "img/yuangong3.22e9d16d.jpg";